<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
#app {
  font-family: "SourceHanSansSC-Medium", Helvetica, Arial, sans-serif;
}
body{
  overflow: hidden;
  min-width: 1024px;
  /* 当显示dialog的时候 body 默认多出了一个 paading-right */
  padding-right:0px!important
}
// 全局树形控件样式修改
  .el-tree-node__content:hover {
    background-color: #FAFBFC !important;
  }

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: transparent !important;
    font-weight: 600;
    color: black;
  }

  .el-tree-node__content {
    height: 28px !important;
    color: #000;
    padding: 0 !important;
  }
//虚线添加开始===========
  .el-tree>.el-tree-node:after {
    border-top: none;
  }

  .el-tree-node {
    position: relative;
    padding-left: 0;
    // &:first-child{
    //   padding-left: 0;
    // }
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree>.el-tree-node:before {
    border-left: none;
  }
  .el-tree>.el-tree-node:after {
    border-top: none;
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 0 !important;
  }

  .el-tree-node:before {
    content: "";
    left: -10px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -8px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #cbcdce;
    bottom: 0px;
    height: 100%;
    top: -22px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #cbcdce;
    height: 20px;
    top: 17px;
    width: 8px;
  }

  //虚线添加结束===========
</style>



// WEBPACK FOOTER //
// src/App.vue